import { useContext } from "react";
import AuthContext from "../context/AuthContext";

export const usePermissions = () => {
  const { idRole } = useContext(AuthContext);

  return {
    isAdmin: idRole === 0,
    isClientRole: idRole === 3,
    canManageDesigns: idRole !== null && [0, 1].includes(idRole),
    canManagePulling: idRole === 0,
    canManageToolsRun: idRole === 0,
    canManageCOI: idRole === 0,
    canManagePumpTracker: idRole !== null && [0, 1, 2].includes(idRole),
    canManageCoiPump: idRole !== null && [0, 1, 2].includes(idRole),
    canManageProducts: idRole !== null && [0, 1].includes(idRole),
    canManageSales: idRole !== null && [0, 1].includes(idRole),
    canManageClients: idRole !== null && [0, 1, 2].includes(idRole),
    canDeleteClients: idRole !== null && [0, 1].includes(idRole),
    canManageWells: idRole !== null && [0, 1, 2].includes(idRole),
    canDeleteWells: idRole !== null && [0, 1].includes(idRole),
  };
};
